import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '@auth/hooks';
import { userHasPermission } from '@app/util/permissions';

export default function Permission({ permission, mode = 'remove', children }) {
  const { user } = useAuth();
  const [hasPermission, setHasPermission] = useState(false);
  const getHidden = () => {
    return mode === 'remove' ? null : (
      <div style={{ display: 'none' }}>{children}</div>
    );
  };

  useEffect(() => {
    setHasPermission(userHasPermission(user, permission));
  }, [permission]);

  return hasPermission ? children : getHidden();
}

Permission.propTypes = {
  permission: PropTypes.string,
  mode: PropTypes.oneOf(['hide', 'remove']),
  children: PropTypes.element,
};
